var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CreationsModuleForm',_vm._b({attrs:{"content":_vm._model},on:{"update:content":function($event){_vm._model=$event}}},'CreationsModuleForm',{ pickRelated: _vm.pickRelated, relatedService: _vm.relatedService },false))}
var staticRenderFns = []

export { render, staticRenderFns }